import React from 'react';
import { Form, Row, Col, Button, Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import DayMonthPicker from 'helpers/DayMonthPicker';
import 'react-datepicker/dist/react-datepicker.css';
import { registerLocale } from 'react-datepicker';
import pt_BR from 'date-fns/locale/pt-BR';
import Input from 'helpers/Input';

const CompaniesFormContacts = ({
  contacts,
  setContacts,
  deleted_contacts,
  setDeletedContacts
}) => {
  registerLocale('pt_BR', pt_BR);
  const { t } = useTranslation();

  const addContact = () => {
    const updateArray = [...contacts];

    updateArray.push({
      name: '',
      email: '',
      phone: '',
      cell_phone: '',
      job: '',
      birthday: '',
      gdn: 0,
      comments: ''
    });

    setContacts(updateArray);
  };

  const handleChangeContact = (e, k) => {
    const updateArray = [...contacts];
    updateArray[k][e.target.name] = e.target.value;
    setContacts(updateArray);
  };

  const deleteContact = k => {
    const updateArray = [...contacts];

    if (contacts[k]['id']) {
      const updateArrayDeletedContacts = [...deleted_contacts];
      updateArrayDeletedContacts.push(contacts[k]['id']);
      setDeletedContacts(updateArrayDeletedContacts);
    }

    updateArray.splice(k, 1);
    setContacts(updateArray);
  };

  return (
    <>
      <Row>
        <Col>
          <h5>{t('title:company contacts')}</h5>
        </Col>
      </Row>
      <Row className="mt-4">
        <Col>
          <Button size="sm" className="login-btn mr-1" variant="primary-login" onClick={addContact}>
            <i className="fas fa-plus" />
            &nbsp;
            {t('label:add contact')}
          </Button>
        </Col>
      </Row>
      {contacts.map((contact, k) => (
        <Row key={k} className="mt-2">
          <Col>
            <Card className="p-3 m-2">
              <Row>
                <Col>
                  <Form.Group>
                    <Form.Label>{t('label:name')}</Form.Label>
                    <Form.Control
                      name="name"
                      value={contact.name}
                      onChange={e => handleChangeContact(e, k)}
                      required
                    />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group>
                    <Form.Label>{t('label:email')}</Form.Label>
                    <Form.Control
                      type="email"
                      name="email"
                      value={contact.email}
                      onChange={e => handleChangeContact(e, k)}
                      required
                    />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group>
                    <Form.Label>{t('label:phone')}</Form.Label>
                    <Input.Phone
                      name="phone"
                      value={contact.phone}
                      onChange={e => handleChangeContact(e, k)}
                      required
                    />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group>
                    <Form.Label>{t('label:cell phone')}</Form.Label>
                    <Input.Phone
                      cell={1}
                      name="cell_phone"
                      value={contact.cell_phone}
                      onChange={e => handleChangeContact(e, k)}
                      required
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group>
                    <Form.Label>{t('label:job')}</Form.Label>
                    <Form.Control
                      name="job"
                      value={contact.job}
                      onChange={e => handleChangeContact(e, k)}
                      required
                    />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group>
                    <Form.Label>{t('label:birthday')}</Form.Label>
                    <DayMonthPicker
                      selected={contact.birthday}
                      onChange={date =>
                        handleChangeContact(
                          { target: { name: 'birthday', value: date } },
                          k
                        )
                      }
                    />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group>
                    <Form.Label>{t('label:gdn')}</Form.Label>
                    <Form.Control
                      name="gdn"
                      as="select"
                      value={contact.gdn}
                      onChange={e => handleChangeContact(e, k)}
                    >
                      <option value={0}>{t('label:no')}</option>
                      <option value={1}>{t('label:yes')}</option>
                    </Form.Control>
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group>
                    <Form.Label>{t('label:comments')}</Form.Label>
                    <Form.Control
                      name="comments"
                      value={contact.comments}
                      onChange={e => handleChangeContact(e, k)}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Button
                    size="sm"
                    variant="danger"
                    onClick={() => deleteContact(k)}
                  >
                    <i className="fas fa-times"></i>&nbsp;
                    {t('label:remove contact')}
                  </Button>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      ))}
    </>
  );
};

export default CompaniesFormContacts;
